import { makeAutoObservable, toJS } from "mobx"

import AssignmentCollection from "./AssignmentCollection"
import { Section } from "../models/Section"

export default class SectionCollection {
  items: Section[]
  assignmentCollection: AssignmentCollection

  constructor(assignmentCollection: AssignmentCollection, sectionParams: any[]) {
    makeAutoObservable(this, {}, { autoBind: true })
    this.assignmentCollection = assignmentCollection
    this.items = sectionParams.map((rp) => new Section(assignmentCollection, rp))
  }

  get length(): number {
    return this.items.length
  }

  findById(sectionId: number): Section | undefined {
    return this.items.find((s: Section) => s.id === sectionId)
  }

  incompleteSections() {
    return this.items.filter((s: Section) => s.isExactlyFull() === false).length
  }

  moveDown(section: Section): boolean {
    let index = this.items.findIndex((s) => s.id === section.id)
    if (index < this.items.length - 1) {
      let temp = this.items[index + 1]
      this.items[index + 1] = this.items[index]
      this.items[index] = temp
      this.items[index + 1].number++
      this.items[index].number--
      return true
    }
    return false
  }

  moveUp(section: Section): boolean {
    let index = this.items.findIndex((s) => s.id === section.id)
    if (index > 0) {
      let temp = this.items[index - 1]
      this.items[index - 1] = this.items[index]
      this.items[index] = temp
      this.items[index - 1].number--
      this.items[index].number++
      return true
    }
    return false
  }

  toJS(): object[] {
    return toJS(
      this.items.map((section) => {
        return { id: section.id }
      }),
    )
  }
}
